export const auctionItemFallbackImage = '/images/default.png';
